import { useState } from "react";
import axios from "axios";

export default function LabourRequirementReport() {
  const [searchText, setSearchText] = useState("");

  const token = sessionStorage.getItem("token");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    if (!fromDate || !toDate) {
      alert("Select both dates");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.get(
        "https://irc.zentelex.com//api/reports/labour/requirement",
        {
          params: { fromDate, toDate },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setData(res.data.data || []);
    } catch (err) {
      alert("Failed to load report");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = data.filter((row) => {
    const search = searchText.toLowerCase();

    return (
      row.entryDate?.toLowerCase().includes(search) ||
      row.clientName?.toLowerCase().includes(search) ||
      row.product?.toLowerCase().includes(search) ||
      String(row.restacking)?.includes(search) ||
      String(row.stitching)?.includes(search) ||
      String(row.sweeping)?.includes(search) ||
      String(row.bulk)?.includes(search) ||
      String(row.others)?.includes(search) ||
      String(row.total_labours)?.includes(search)
    );
  });

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="card shadow-sm mb-4 border-0 bg-primary bg-gradient text-white">
        <div className="card-body">
          <h4 className="fw-bold mb-1">Labour Requirement Report</h4>
          <p className="mb-0 opacity-75">
            Date, Client & Product wise manpower requirement
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="card shadow-sm mb-4 border-0 bg-light">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold text-primary">
                From Date
              </label>
              <input
                type="date"
                className="form-control border-primary"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold text-primary">
                To Date
              </label>
              <input
                type="date"
                className="form-control border-primary"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            <div className="col-md-4 d-flex align-items-end">
              <button
                className="btn btn-primary w-100 fw-semibold"
                onClick={fetchReport}
                disabled={loading}
              >
                {loading ? "Loading..." : "Generate Report"}
              </button>
            </div>

            <div className="row mt-3">
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control border-success"
                  placeholder="🔍 Search Client / Product / Date..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card shadow-sm border-0">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="table-primary text-center">
                <tr>
                  <th>Date</th>
                  <th>Client</th>
                  <th>Product</th>
                  <th className="text-warning">Restacking</th>
                  <th className="text-info">Stitching</th>
                  <th className="text-secondary">Sweeping</th>
                  <th className="text-primary">Bulk</th>
                  <th className="text-dark">Others</th>
                  <th>Total Labour</th>
                </tr>
              </thead>

              <tbody className="text-center">
                {!loading && data.length === 0 && (
                  <tr>
                    <td colSpan="9" className="text-muted py-4">
                      No data found
                    </td>
                  </tr>
                )}

                {filteredData.map((row, i) => (
                  <tr key={i}>
                    <td>{row.entryDate}</td>
                    <td className="fw-semibold">{row.clientName}</td>
                    <td>{row.product}</td>

                    <td className="fw-semibold text-warning">
                      {row.restacking}
                    </td>
                    <td className="fw-semibold text-info">{row.stitching}</td>
                    <td className="fw-semibold text-secondary">
                      {row.sweeping}
                    </td>
                    <td className="fw-semibold text-primary">{row.bulk}</td>
                    <td className="fw-semibold">{row.others}</td>

                    <td className="fw-bold text-success fs-6">
                      {row.total_labours}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredData.length > 0 && (
            <div className="card-footer bg-success-subtle text-end fw-bold">
              Records Found: <span className="text-success">{data.length}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
